export default "__VITE_ASSET__D8Lfi5YR__"